import { defineStore } from 'pinia'
import { ref } from 'vue'
import { useApi } from '@/utils/axios'
import { PAGAMENTO_ROTAS } from '@/utils/apiRoutes'

export const useFormaPagamentoStore = defineStore('formaPagamento', () => {
  const data = ref([])
  const loading = ref(false)
  const error = ref(null)

  const fetchFormasPagamento = async () => {
    loading.value = true
    error.value = null

    try {
      const response = await useApi(PAGAMENTO_ROTAS.FORMAS_PAGAMENTO).fetch({
        params: { status: 1 }, // Apenas formas de pagamento ativas
      })
      if (response?.data) {
        data.value = response.data.map((item) => ({
          title: item.descricao,
          value: item.id,
        }))
      } else {
        error.value = 'Resposta da API em formato inesperado'
      }
    } catch (err) {
      error.value = err.message || 'Erro ao carregar formas de pagamento'
      throw err
    } finally {
      loading.value = false
    }
  }

  return {
    data,
    loading,
    error,
    fetchFormasPagamento,
  }
})
